import React from 'react'
import AgenciesList from '../../pages/Partnerships/Agencies/List'
import AgenciesUpdate from '../../pages/Partnerships/Agencies/Update'
import AgenciesCreate from '../../pages/Partnerships/Agencies/Create'
import AgenciesView from '../../pages/Partnerships/Agencies/View'
import PrivateRoute from '../PrivateRoute'
import { CustomSwitch } from '../../components/CustomSwitch'

export const AgenciesRouter = (): JSX.Element => (
  <CustomSwitch>
    <PrivateRoute
      path="/partnerships/agencies"
      exact
      component={AgenciesList}
    />
    <PrivateRoute
      path="/partnerships/agencies/create"
      component={AgenciesCreate}
      exact
    />
    <PrivateRoute
      path="/partnerships/agencies/view/:id"
      component={AgenciesView}
      exact
    />
    <PrivateRoute
      path="/partnerships/agencies/update/:id"
      component={AgenciesUpdate}
      exact
    />
  </CustomSwitch>
)
